
































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Badge, Button, Card, Tag, Tooltip } from 'element-ui';
import Priority from '@/components/inquiry/Priority.vue';
import AssignOperator from '@/components/shipment/AssignOperator.vue';
import {
  InquiryFields, TransportationTypeEnum, CargoTypeEnum, ShipmentStatusEnum
} from '@/types/graphql/schemaTypes';

import get from 'lodash/get';

@Component({
  components: {
    AssignOperator,
    Priority,
    'el-badge': Badge,
    'el-button': Button,
    'el-card': Card,
    'el-tag': Tag,
    'el-tooltip': Tooltip
  }
})
export default class InquiryListItem extends Vue {
  @Prop() public inquiry!: InquiryFields;

  private cargo() {
    if (this.inquiry.transportationType === TransportationTypeEnum.air) {
      return TransportationTypeEnum.air.toUpperCase();
    }
    return this.inquiry.cargoType || '-';
  }

  private cargoDetails() {
    if (!this.inquiry.cargoDescription) {
      return;
    }

    const description = [];

    if (this.inquiry.cargoType === CargoTypeEnum.FCL && this.inquiry.cargoDescription.containers) {
      this.inquiry.cargoDescription.containers.forEach((container, index) => {
        if (index > 1) { // more than 2 ? => elippsis
          description.push('...');
          return;
        }
        description.push(
          `${container.requestedContainerType} ✕ ${container.requestedContainerCount}`
        );
      });
    } else if (this.inquiry.cargoDescription.parcels) {
      this.inquiry.cargoDescription.parcels.forEach((parcel, index) => {
        if (index > 1) { // more than 2 ? => elippsis
          description.push('...');
          return;
        }
        description.push(
          `${this.$t(`parcel.packaging-types.${parcel.packagingType}`)} ✕ ${parcel.quantity}`
        );
      });
    }
    return description.join(', ');
  }

  private latestIsCustomer() {
    return get(this.inquiry, 'lastPublicChannelMessage.sender.senderType') === 'shipper';
  }

  /**
   * @returns false if no quoteDueDate
   * @return if quoteDueDate is is after today(UTC) => true else false
   */
  private expired() {
    if (!this.inquiry.quoteDueDate) {
      return false;
    }

    return new Date(this.inquiry.quoteDueDate).getTime() <= new Date().getTime();
  }

  private quoteClass() {
    if (!this.inquiry.quoteDueDate) {
      return '';
    }

    return this.expired() ? 'text-red-500' : 'text-blue-500';
  }

  private quoteDetails() {
    if (!this.inquiry.billItemTotal) {
      return;
    }
    return this.inquiry.showTotal
      ? this.$t('shared.currency-value', { value: this.inquiry.billItemTotal.toLocaleString() })
      : this.$t('inquiry.quote.multiple-quote');
  }
}
